module.exports = __webpack_public_path__ + "img/AdaptivePill-poster.a2808f40.jpg";